<template>
    <Link :href="href" :class="classes">
        <slot />
    </Link>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Link,
    },

    props: ['href', 'active'],

    computed: {
        classes() {
            return this.active
                ? 'bg-gray-900 text-white px-3 py-2 rounded-md font-medium text-base transition ubuntu'
                : 'text-gray-300 hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md font-medium text-base transition ubuntu'
        }
    }
}
</script>
